import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { processFlattenStyles } from '@wix/native-pro-gallery-utils';
export const WixProGalleryWithFlattenOptions = Gallery => props => {
  const {
    flattenOptions,
    flattenFullscreenOverrides
  } = props;
  const {
    options,
    fullscreenOptions
  } = processFlattenStyles(flattenOptions, flattenFullscreenOverrides);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Gallery, _extends({}, props, {
    options: options,
    fullscreenOptions: fullscreenOptions,
    flattenOptions: flattenOptions
  })));
};
//# sourceMappingURL=withOptions.js.map